import { render } from "./as-files-selector.vue?vue&type=template&id=fa15535c&scoped=true&ts=true"
import script from "./as-files-selector.vue?vue&type=script&lang=ts"
export * from "./as-files-selector.vue?vue&type=script&lang=ts"

import "./as-files-selector.vue?vue&type=style&index=0&id=fa15535c&scoped=true&lang=scss"

import exportComponent from "D:\\a\\1\\s\\src\\WebUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa15535c"]])

export default __exports__